import { z } from 'zod';

export const releaseTemplateSwitchSchema = z.object({
  reason: z.string().trim().min(10, 'Describe the reconciliation in at least 10 characters.').max(500),
});
export type ReleaseTemplateSwitchFormData = z.infer<typeof releaseTemplateSwitchSchema>;
